import React from "react";

import { CheckoutBundlePopupContainer } from "./CheckoutBundlePopup.container";
import { CheckoutBundlePopupView } from "./CheckoutBundlePopup.view";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export function CheckoutBundlePopup(props) {
  const {
    bundle,
    earlyAccess,
    ticketType,
    course,
    tutors,
    locations,
    onClose
  } = props;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_CLIENT_KEY}
    >
      <CheckoutBundlePopupContainer.Provider
        initialState={{
          bundle,
          earlyAccess,
          ticketType,
          course,
          locations,
          tutors,
          onClose
        }}
      >
        <CheckoutBundlePopupView onClose={onClose} />
      </CheckoutBundlePopupContainer.Provider>
    </GoogleReCaptchaProvider>
  );
}

CheckoutBundlePopup.propTypes = {};
